import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { api } from '../config/api';
import Modal from 'react-bootstrap/Modal';
import { Dropdown, DropdownButton, Button, FormControl } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Toast from 'react-bootstrap/Toast';
import Image from 'react-bootstrap/Image';
import Accordion from 'react-bootstrap/Accordion';
import {
  statusRequiresInterviewDate,
  getPersistedCandidateStatus,
} from '../utils/candidateStatus';
import StatusBadge from './ui/StatusBadge';
import { matchesUploadedDateRange, getDefaultRequirementListMonthRange, matchesDefaultRequirementListMonthRange } from '../utils/requirementDateFilter';
import RequirementDateRangeFilter from './ui/RequirementDateRangeFilter';
import StatusHistorySection from './ui/StatusHistorySection';
import StatusUpdatePanel from './ui/StatusUpdatePanel';
import SourceProfileDocumentFields from './ui/SourceProfileDocumentFields';
import { mergeCandidateStatusRemarkUpdate } from '../utils/statusRemarks';
import { buildApiAssetUrl } from '../utils/apiAssetUrl';
import { getDecryptedData } from '../utils/authStorage';
import {
  getRequirementCreatorId,
  getRequirementSourceBadgeClass,
  getRequirementSourceFromRow,
} from '../utils/requirementSource';
import PageShell from './ui/PageShell';
import ActionIcon from './ui/ActionIcon';
import {
  getUploadedProfileCount,
  getOngoingProfileCount,
  getNoActionCandidatesForRequirement,
  getActiveCandidatesForRequirement,
  getNoOfProfilesCandidatesForRequirement,
} from '../utils/requirementProfileCount';
import { useLayout, CANDIDATE_ACTIVITY_REFRESH_KEYS } from '../layout/AppLayout';
import { showSuccess, showError, showInfo } from '../utils/toast';
import { getApiErrorMessage } from '../utils/apiError';
import { submitStatusUpdate } from '../utils/submitStatusUpdate';
import {
  applyCandidateStatusUpdate,
  fetchRequirementRecruiters,
  normalizeCandidateRecord,
  normalizeRecruiterCandidateGroups,
} from '../utils/candidateListState';
import { highlightProfileRow } from '../utils/profileDeepLink';
import { formatDisplayDate, formatInterviewDate, formatLwdDisplay, toDateInputValue } from '../utils/dateFormat';
import {
  REQUIREMENT_TYPE_OPTIONS,
  isRequirementWorkBlocked,
  matchesRequirementTypeFilter,
  normalizeRequirementType,
} from '../utils/requirementType';
import RequirementTypeSelect from './ui/RequirementTypeSelect';
import PrioritySelect from './ui/PrioritySelect';
import PriorityBadge from './ui/PriorityBadge';
import { sortByRequirementTypeThenPriority } from '../utils/requirementPriority';
import { parseCsvText } from '../utils/csvTransfer';
import { EXCEL_ACCEPT, exportToExcel, downloadExcelTemplate, parseImportFile } from '../utils/excelTransfer';
import {
  getUploadDisplayState,
  UploadStatusBadge,
  UploadActionButton,
  confirmAndToggleAssignedUserUploadStatus,
} from './requirements/assignedUserUploadUi';
import {
  buildImportPayloads,
  getRequirementImportValidationHint,
  mapRequirementToExportRow,
  REQUIREMENT_IMPORT_EXAMPLE,
  REQUIREMENT_IMPORT_TEMPLATE_COLUMNS,
  REQUIREMENT_LIST_EXPORT_COLUMNS,
} from '../utils/requirementExport';
import { editRequirement, importRequirements } from '../services/requirementService';
import RequirementRecruitersModal from './requirements/RequirementRecruitersModal';
import RequirementClaimsModal from './requirements/RequirementClaimsModal';
import RequirementRejectedModal from './requirements/RequirementRejectedModal';
import { getRejectedCandidates } from '../services/candidateService';
import RequirementJdActions from './requirements/RequirementJdActions';
import RequirementClientSelect from './requirements/RequirementClientSelect';
import {
  MIN_ASSESSMENTS,
  appendRequirementFormData,
  padAssessments,
  validateAssessmentsInput,
} from '../utils/requirementAssessments';


const DEFAULT_LIST_PAGE_SIZE = 10;
const INITIAL_REQUIREMENT_LIST_MONTH_RANGE = getDefaultRequirementListMonthRange();

function Requirements({ scope = '' }) {
    let [requirements, SetRequirements] = useState([]);
    const [, setCandidateCounts] = useState({});
    const [candidateDetails,setCandidateDetails] = useState([]);
    const [claimedByCounts, setClaimedByCounts] = useState({});
    const [searchTerm] = useState(''); // State for search term
    const [showClaimedUsers, setShowClaimedUsers] = useState([]);
    const [showClaimsModal, setShowClaimsModal] = useState(false);
    const [claimsModalMeta, setClaimsModalMeta] = useState({ regId: '' });
    const [showProfilesModal, setShowProfilesModal] = useState(false);
    const [profilesModalMeta, setProfilesModalMeta] = useState({
        regId: '',
        mode: 'all',
        requirementId: '',
        scopedCandidates: null,
    });
    const [showRejectedModal, setShowRejectedModal] = useState(false);
    const [rejectedModalMeta, setRejectedModalMeta] = useState({ regId: '', requirementId: '' });
    const [rejectedRows, setRejectedRows] = useState([]);
    const [rejectedLoading, setRejectedLoading] = useState(false);
    const [showB, setShowB] = useState(false);
    const [lgShow, setLgShow] = useState(false);
    const [lagShow, setLagShow] = useState(false);
    const [showAssigns,setShowAssigns] = useState(false);
    const [recruitersData, setRecruitersData] = useState([]);
    const [requirementData, SetRequirementData] = useState({}); // Changed to object
    const requirementTypes = REQUIREMENT_TYPE_OPTIONS;
    const [selectedTypes, setSelectedTypes] = useState(['High', 'Medium']);
    const [candidateId,setCandidateId]=useState('');
    const [showEditModal, setShowEditModal] = useState(false);
    const [editJdFile, setEditJdFile] = useState(null);
    const [assignedUserDetails,setAssignedUserDetails] = useState([]);
    const [remainingUsers, setRemainingUsers] = useState([]);
    const [selectedReqId,setSelectedReqId]= useState('');
    // State for filters
    const [selectedCandidateStatus] = useState('');
    const [candidateName] = useState('');
    const [expandedId, setExpandedId] = useState(null);
    const [openItems, setOpenItems] = useState({}); // Track open/close state by item ID
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState('');
    const { openFormModal, tableRefresh, triggerTableRefresh } = useLayout();
    const [searchParams, setSearchParams] = useSearchParams();
    const focusedRequirementId = searchParams.get('requirementId') || '';
    const focusedProfileId = searchParams.get('profileId') || '';
    const isMyRequirements = scope === 'mine';
    const currentAdminId = getDecryptedData('Id');
    const sessionUserType = getDecryptedData('User Type');
    const canUploadCandidateDocuments = ['Admin', 'TeamLead', 'User'].includes(sessionUserType);
    const importInputRef = useRef(null);
    const [flashRequirementId, setFlashRequirementId] = useState('');
    const highlightPositionedRef = useRef('');
    const profileDeepLinkRef = useRef('');
    const profileModalDeepLinkRef = useRef('');
    const profilesReloadRequestRef = useRef(0);

    const reloadOpenProfilesModal = useCallback(async (requirementId) => {
        const reqId = requirementId || profilesModalMeta.requirementId;
        if (!reqId) return [];

        const requestId = profilesReloadRequestRef.current + 1;
        profilesReloadRequestRef.current = requestId;

        try {
            const recruiters = normalizeRecruiterCandidateGroups(
              await fetchRequirementRecruiters(api, reqId)
            );
            if (profilesReloadRequestRef.current !== requestId) return recruiters;
            setRecruitersData(recruiters);
            return recruiters;
        } catch (error) {
            const message = error.message || '';
            if (profilesReloadRequestRef.current === requestId && /not found|no recruiters/i.test(message)) {
                setRecruitersData([]);
            }
            return [];
        }
    }, [profilesModalMeta.requirementId]);

  const toggleFlip = (id) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [id]: !prevState[id],  // Toggle the specific item’s state by ID
    }));
  };

   

    // Function to filter candidates
    const filteredRecruitersData = recruitersData.map(item => ({
        ...item,
        candidates: item.candidates.filter(candidate => {
            const recentStatus = getPersistedCandidateStatus(candidate);

            const matchesStatus = selectedCandidateStatus ? recentStatus === selectedCandidateStatus : true;
            const matchesName = candidateName 
                ? `${candidate.firstName} ${candidate.lastName}`.toLowerCase().includes(candidateName.toLowerCase())
                : true;

            return matchesStatus && matchesName;
        })
    })).filter(item => item.candidates.length > 0); // Keep only items with candidates


    
const [formData, setFormData] = useState({
  id:'',
  client: '',
  typeOfContract: '',
  startDate: '',
  duration: '',
  location: '',
  sourceCtc: '',
  ectc: '',
  qualification: '',
  yearsExperience: '',
  relevantExperience: '',
  skill: '',
  role: '',
  requirementtype: '',
  assessments: [], // Initialize assessments as an array
});

    const [selectedStatus, setSelectedStatus] = useState('');
    const [statusInterviewDate, setStatusInterviewDate] = useState('');
    const [statusRemark, setStatusRemark] = useState('');
    const [searchReq, setSearchReq] = useState("");
    const [roleFilter, setRoleFilter] = useState('');
    const [uploadedFromDate, setUploadedFromDate] = useState(INITIAL_REQUIREMENT_LIST_MONTH_RANGE.from);
    const [uploadedToDate, setUploadedToDate] = useState(INITIAL_REQUIREMENT_LIST_MONTH_RANGE.to);
    const [dateFilterField, setDateFilterField] = useState('uploadedDate');
    const [listPage, setListPage] = useState(1);

   


    const handleSearchChange = (event) => {
        setSearchReq(event.target.value);
        setListPage(1);
    };

    const clearFocusedRequirement = () => {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.delete('requirementId');
        nextParams.delete('profileId');
        setSearchParams(nextParams);
        setListPage(1);
        setFlashRequirementId('');
        profileDeepLinkRef.current = '';
    };

    const handleCheckboxChange = (type) => {
        setListPage(1);
        if (type === 'all') {
            setSelectedTypes(selectedTypes.length === requirementTypes.length ? [] : requirementTypes);
        } else {
            setSelectedTypes(prevSelected => 
                prevSelected.includes(type)
                ? prevSelected.filter(item => item !== type)
                : [...prevSelected, type]
            );
        }
    };

    const getDropdownTitle = () => {
        if (selectedTypes.length === requirementTypes.length) return 'All';
        if (selectedTypes.length === 0) return 'Select';
        return selectedTypes.join(', ');
    };

    const handleRequirementTypeUpdated = (reqId, nextType, updatedRequirement) => {
        SetRequirements((prev) => prev.map((item) => {
            if (item._id !== reqId) return item;
            return {
                ...item,
                requirementtype: nextType,
                ...(updatedRequirement?.uploadedDate != null
                    ? { uploadedDate: updatedRequirement.uploadedDate }
                    : {}),
            };
        }));
    };

    const handlePriorityUpdated = (reqId, nextPriority) => {
        SetRequirements((prev) => prev.map((item) => (
            item._id === reqId ? { ...item, priority: nextPriority } : item
        )));
    };

    const toggleShowB = () => setShowB(!showB);
    
    useEffect(() => {
        fetchRequirements();
    }, [tableRefresh.requirements, tableRefresh.candidates]);

    useEffect(() => {
        const clientFilter = searchParams.get('client');
        const roleFilterParam = searchParams.get('role');
        const fromParam = searchParams.get('from');
        const toParam = searchParams.get('to');
        const dateFieldParam = searchParams.get('dateField');
        const typesParam = searchParams.get('types');

        if (clientFilter) {
            setSearchReq(clientFilter);
        }
        if (roleFilterParam) {
            setRoleFilter(roleFilterParam);
        }
        if (fromParam) {
            setUploadedFromDate(fromParam);
        }
        if (toParam) {
            setUploadedToDate(toParam);
        }
        if (dateFieldParam === 'startDate') {
            setDateFilterField('startDate');
        }
        if (typesParam) {
            const nextTypes = typesParam
                .split(',')
                .map((value) => normalizeRequirementType(value.trim()))
                .filter(Boolean);
            if (nextTypes.length) {
                setSelectedTypes(nextTypes);
            }
        }
    }, [searchParams]);

    useEffect(() => {
        if (!expandedId) return undefined;

        let cancelled = false;
        const reloadExpandedProfiles = async () => {
            try {
                const response = await api.get(`/api/recruiters/${expandedId}`);
                if (!cancelled) {
                    setRecruitersData(
                      normalizeRecruiterCandidateGroups(response.data?.recruiters || [])
                    );
                }
            } catch (error) {
                const status = error.response?.status;
                const message = error.message || '';
                if (!cancelled && (status === 404 || /not found|no recruiters/i.test(message))) {
                    setRecruitersData([]);
                }
            }
        };

        reloadExpandedProfiles();
        return () => {
            cancelled = true;
        };
    }, [expandedId, tableRefresh.candidates, tableRefresh.requirements]);

    useEffect(() => {
        if (!showProfilesModal || !profilesModalMeta.requirementId) return undefined;

        reloadOpenProfilesModal(profilesModalMeta.requirementId);
        return undefined;
    }, [showProfilesModal, profilesModalMeta.requirementId, reloadOpenProfilesModal]);

    const fetchRequirements = async () => {
      setLoading(true);
      setLoadError('');
      try {
          const response = await api.get('/admingetrequirements');
          const data = response.data;
  
          if (data.status === 'Error') {
              setLoadError(data.msg || 'Failed to load requirements.');
              SetRequirements([]);
              return;
          }
  
          if (Array.isArray(data)) {
              SetRequirements(data);
              const counts = {};
              data.forEach((req) => {
                  counts[String(req._id)] = getUploadedProfileCount(req);
              });
              setCandidateCounts(counts);
          } else {
              setLoadError('Unexpected response format from server.');
              SetRequirements([]);
          }
      } catch (err) {
          console.error('Error fetching requirements:', err);
          setLoadError(err.message || 'Failed to load requirements.');
          SetRequirements([]);
      } finally {
          setLoading(false);
      }
  };
  
  
    useEffect(() => {
        const fetchClaimedByCounts = async () => {
            if (!Array.isArray(requirements) || requirements.length === 0) {
                setClaimedByCounts({});
                return;
            }

            try {
                const entries = await Promise.all(
                    requirements.map(async (req) => {
                        try {
                            const response = await api.get(`/api/requirements/${req._id}/claimedByCount`);
                            return [req._id, response.data.claimedByCount || 0];
                        } catch (err) {
                            return [req._id, 0];
                        }
                    })
                );
                setClaimedByCounts(Object.fromEntries(entries));
            } catch (err) {
                console.log('Error fetching claimedBy counts:', err);
            }
        };

        fetchClaimedByCounts();
    }, [requirements]);

    const fetchClaimedUsersDetails = async (requirementId, regId) => {
        try {
            const response = await api.get(`/api/requirements/${requirementId}/claimedByDetails`);
            setShowClaimedUsers(response.data.claimedUsers || []);
            setClaimsModalMeta({ regId: regId || '' });
            setShowClaimsModal(true);
        } catch (error) {
            console.error(`Error fetching claimed users for requirement ${requirementId}:`, error);
        }
    };

const openProfilesModal = async (reqId, regId, mode = 'all', scopedCandidates = null) => {
  try {
      const response = await api.get(`/api/recruiters/${reqId}`);
      setRecruitersData(normalizeRecruiterCandidateGroups(response.data.recruiters || []));
      setProfilesModalMeta({
        regId: regId || '',
        mode,
        requirementId: reqId,
        scopedCandidates: Array.isArray(scopedCandidates) ? scopedCandidates : null,
      });
      setShowProfilesModal(true);
  } catch (err) {
      const message = err.message || '';
      if (/not found|no recruiters/i.test(message)) {
        setRecruitersData([]);
        setProfilesModalMeta({
          regId: regId || '',
          mode,
          requirementId: reqId,
          scopedCandidates: Array.isArray(scopedCandidates) ? scopedCandidates : null,
        });
        setShowProfilesModal(true);
        return;
      }
      toggleShowB();
  }
};

const closeProfilesModal = () => {
  setShowProfilesModal(false);
  setProfilesModalMeta({ regId: '', mode: 'all', requirementId: '', scopedCandidates: null });
};

const closeClaimsModal = () => {
  setShowClaimsModal(false);
  setShowClaimedUsers([]);
  setClaimsModalMeta({ regId: '' });
};

const openRejectedModal = async (requirementId, regId) => {
  setRejectedModalMeta({ regId: regId || '', requirementId });
  setShowRejectedModal(true);
  setRejectedLoading(true);
  try {
    const userId = getDecryptedData('Id');
    const response = await getRejectedCandidates(requirementId, userId);
    setRejectedRows(response.rows || []);
  } catch (error) {
    console.error('Error loading rejected candidates:', error);
    setRejectedRows([]);
    showError(error.message || 'Unable to load rejected profiles.');
  } finally {
    setRejectedLoading(false);
  }
};

const closeRejectedModal = () => {
  setShowRejectedModal(false);
  setRejectedModalMeta({ regId: '', requirementId: '' });
  setRejectedRows([]);
};

const handleRejectedStatusUpdated = useCallback((candidateId, newStatus) => {
  setRejectedRows((prev) => prev.map((row) => (
    row.candidateId === candidateId
      ? { ...row, currentStatus: newStatus }
      : row
  )));
  triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
}, [triggerTableRefresh]);

const toggleAccordion = async (id) => {
    if (expandedId === id) {
        setExpandedId(null);
        return;
    }

    try {
      setRecruitersData([]);
      const response = await api.get(`/api/recruiters/${id}`);
      setRecruitersData(normalizeRecruiterCandidateGroups(response.data?.recruiters || []));
      toggleFlip(id);
      setExpandedId(id);
    } catch (error) {
      const status = error.response?.status;
      const message = error.message || '';
      if (status === 404 || /not found|no recruiters/i.test(message)) {
        setRecruitersData([]);
        toggleFlip(id);
        setExpandedId(id);
        return;
      }
      console.error('Error loading recruiters:', error);
      showError(error.message || 'Unable to load recruiter details for this requirement.');
    }
};
    const requirementDetails = async (id) => {
        try {
            const response = await api.get(`/getrequirements/${id}`);
            SetRequirementData(response.data); // Ensure this returns an object
            
            setLgShow(true);
        } catch (err) {
            console.log(err);
        }
    };
    const CandidateData = async(id)=>{
        try {
            const response = await api.get(`/candidate/${id}`);
                setCandidateDetails(normalizeCandidateRecord(response.data));
                setCandidateId(id);
                setSelectedStatus('');
                setStatusInterviewDate(toDateInputValue(response.data?.interviewDate));
            setLagShow(true)
        } catch (error) {
            console.error('Error fetching candidates:', error);
        } 
    }
 // Fetch candidate details when the modal is opened
    
    const filteredRequirements = requirements.filter(item =>
        (item.requirementtype || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedRequirements = sortByRequirementTypeThenPriority(filteredRequirements);

    const visibleRequirements = useMemo(() => {
        if (focusedRequirementId) {
            const focused = requirements.find((item) => item._id === focusedRequirementId);
            return focused ? [focused] : [];
        }

        const q = searchReq.toLowerCase();
        return sortedRequirements
            .filter((item) =>
                selectedTypes.length === requirementTypes.length
                || matchesRequirementTypeFilter(item.requirementtype, selectedTypes)
            )
            .filter((item) =>
                (item.client || '').toLowerCase().includes(q)
                || String(item.regId || '').toLowerCase().includes(q)
                || String(item._id || '').toLowerCase().includes(q)
                || (item.role || '').toLowerCase().includes(q)
            )
            .filter((item) => (
                !roleFilter
                || (item.role || '').toLowerCase() === roleFilter.toLowerCase()
            ))
            .filter((item) => {
                const dateValue = dateFilterField === 'startDate'
                    ? item.startDate
                    : item.uploadedDate;
                return matchesUploadedDateRange(dateValue, uploadedFromDate, uploadedToDate);
            })
            .filter((item) => (
                !isMyRequirements
                || getRequirementCreatorId(item) === String(currentAdminId)
            ));
    }, [
        sortedRequirements,
        selectedTypes,
        requirementTypes.length,
        searchReq,
        roleFilter,
        uploadedFromDate,
        uploadedToDate,
        dateFilterField,
        focusedRequirementId,
        requirements,
        isMyRequirements,
        currentAdminId,
    ]);

    const totalListPages = Math.max(1, Math.ceil(visibleRequirements.length / DEFAULT_LIST_PAGE_SIZE));
    const currentListPage = Math.min(listPage, totalListPages);
    const pagedRequirements = visibleRequirements.slice(
        (currentListPage - 1) * DEFAULT_LIST_PAGE_SIZE,
        currentListPage * DEFAULT_LIST_PAGE_SIZE
    );

    useEffect(() => {
        if (listPage > totalListPages) {
            setListPage(totalListPages);
        }
    }, [listPage, totalListPages]);

    useEffect(() => {
        highlightPositionedRef.current = '';
        profileDeepLinkRef.current = '';
        profileModalDeepLinkRef.current = '';
    }, [focusedRequirementId, focusedProfileId]);

    useEffect(() => {
        if (!focusedRequirementId || loading || !requirements.length) return;
        if (highlightPositionedRef.current === focusedRequirementId) return;
        highlightPositionedRef.current = focusedRequirementId;
        setListPage(1);
    }, [focusedRequirementId, loading, requirements]);

    useEffect(() => {
        if (!focusedRequirementId || loading) return;
        const isVisibleOnPage = pagedRequirements.some((item) => item._id === focusedRequirementId);
        if (!isVisibleOnPage) return;

        const scrollTimer = window.setTimeout(() => {
            const row = document.getElementById(`requirement-row-${focusedRequirementId}`);
            if (!row) return;
            row.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setFlashRequirementId(focusedRequirementId);
            window.setTimeout(() => setFlashRequirementId(''), 3200);
        }, 150);

        return () => window.clearTimeout(scrollTimer);
    }, [focusedRequirementId, loading, currentListPage, pagedRequirements]);

    useEffect(() => {
        if (!focusedRequirementId || loading || !requirements.length) return;

        const linkKey = `${focusedRequirementId}:${focusedProfileId}`;
        if (profileDeepLinkRef.current === linkKey) return;

        let cancelled = false;
        const expandRequirement = async () => {
            try {
                setRecruitersData([]);
                const response = await api.get(`/api/recruiters/${focusedRequirementId}`);
                if (cancelled) return;
                setRecruitersData(normalizeRecruiterCandidateGroups(response.data?.recruiters || []));
                toggleFlip(focusedRequirementId);
                setExpandedId(focusedRequirementId);
                profileDeepLinkRef.current = linkKey;
            } catch (error) {
                const status = error.response?.status;
                const message = error.message || '';
                if (status === 404 || /not found|no recruiters/i.test(message)) {
                    if (!cancelled) {
                        setRecruitersData([]);
                        toggleFlip(focusedRequirementId);
                        setExpandedId(focusedRequirementId);
                        profileDeepLinkRef.current = linkKey;
                    }
                    return;
                }
                console.error('Failed to open requirement from profile link:', error);
            }
        };

        expandRequirement();
        return () => {
            cancelled = true;
        };
    }, [focusedRequirementId, focusedProfileId, loading, requirements.length]);

    useEffect(() => {
        if (!focusedProfileId || expandedId !== focusedRequirementId) return undefined;
        return highlightProfileRow(focusedProfileId, { delayMs: 450 });
    }, [focusedProfileId, focusedRequirementId, expandedId, recruitersData]);

    useEffect(() => {
        if (!focusedProfileId || expandedId !== focusedRequirementId) return undefined;

        const openKey = `modal:${focusedRequirementId}:${focusedProfileId}`;
        if (profileModalDeepLinkRef.current === openKey) return undefined;

        let cancelled = false;
        const timer = window.setTimeout(() => {
            if (cancelled) return;
            profileModalDeepLinkRef.current = openKey;
            CandidateData(focusedProfileId);
        }, 550);

        return () => {
            cancelled = true;
            window.clearTimeout(timer);
        };
    }, [focusedProfileId, focusedRequirementId, expandedId, recruitersData]);

    const exportRows = useMemo(() => (
        visibleRequirements.map((req) => mapRequirementToExportRow(req, {
            profileCount: getUploadedProfileCount(req),
            claimCount: claimedByCounts[req._id] ?? 0,
        }))
    ), [visibleRequirements, claimedByCounts]);

    const handleDownloadTemplate = () => {
        downloadExcelTemplate(
            'requirements-import-template.xlsx',
            REQUIREMENT_IMPORT_TEMPLATE_COLUMNS,
            REQUIREMENT_IMPORT_EXAMPLE
        );
    };

    const handleExportRequirements = () => {
        if (!exportRows.length) {
            showInfo('No requirements to export.');
            return;
        }
        exportToExcel('requirements-export.xlsx', REQUIREMENT_LIST_EXPORT_COLUMNS, exportRows);
    };

    const handleImportClick = () => {
        importInputRef.current?.click();
    };

    const handleImportFile = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        try {
            const rows = await parseImportFile(file, parseCsvText);
            if (!rows.length) {
                showInfo('No data rows found in the imported file.');
                return;
            }

                const payloads = buildImportPayloads(rows, getDecryptedData('Id'));
                if (!payloads.length) {
                    showError(getRequirementImportValidationHint(rows, payloads));
                    return;
                }

            const result = await importRequirements(payloads, getDecryptedData('Id'));
            if (result.created > 0) {
                showSuccess(result.msg || `Imported ${result.created} requirement(s).`);
                await fetchRequirements();
            }
            if (result.failed?.length) {
                const failedIds = result.failed.map((item) => item.regId).join(', ');
                showError(`${result.failed.length} row(s) failed: ${failedIds}`);
            } else if (!result.created) {
                showError(result.msg || 'No requirements were imported.');
            }
        } catch (err) {
            console.error('Requirement import failed:', err);
            showError('Unable to import requirements. Please use the Excel template.');
        }
        event.target.value = '';
    };

      const handleStatusChange = (e) => {
        const nextStatus = e.target.value;
        setSelectedStatus(nextStatus);
        if (!statusRequiresInterviewDate(nextStatus)) {
          setStatusInterviewDate('');
        }
      };
      
      // Make sure candidateId is properly passed and used
      const handleStatusRemarkAdded = (updatedStatusEntry, updatedCandidate) => {
        if (updatedCandidate) {
          setCandidateDetails(normalizeCandidateRecord(updatedCandidate));
          return;
        }
        if (updatedStatusEntry?._id) {
          setCandidateDetails((prev) => mergeCandidateStatusRemarkUpdate(
            prev,
            updatedStatusEntry._id,
            updatedStatusEntry,
          ));
        }
      };

      const postStatus = async (id) => {
        await submitStatusUpdate({
          api,
          candidateId: id,
          selectedStatus,
          statusRemark,
          statusInterviewDate,
          updatedBy: getDecryptedData('Id'),
          onSuccess: async (responseData) => {
            setSelectedStatus('');
            setStatusInterviewDate('');
            setStatusRemark('');

            const updated = applyCandidateStatusUpdate({
              responseData,
              candidateId: id,
              setRecruitersData,
              setProfilesModalMeta,
              setCandidateDetails,
            });

            await reloadOpenProfilesModal(profilesModalMeta.requirementId || expandedId);

            if (!updated && id) {
              await CandidateData(id);
            }

            triggerTableRefresh(CANDIDATE_ACTIVITY_REFRESH_KEYS);
            handleCloseTotalCandidates();
            handleCloseModal();
          },
        });
      };
      const handleCloseTotalCandidates = () => {};
      const handleCloseModal = () => {};
      // Delete Requirement
      const handleDelete = async (id) => {
        if (!id) {
          console.log("No regId provided");
          return;
        }
    
        // Confirm the action with the user
        const isConfirmed = window.confirm("Are you sure you want to delete this requirement?");
        
        if (!isConfirmed) {
          // If the user cancels, do nothing
          return;
        }
    
        try {
          await api.delete(`/deleteRequirement/${id}`);
          showSuccess('Requirement deleted successfully ✓');
          window.location.reload();
          console.log(`Requirement deleted successfully ✓`);
        } catch (error) {
          showError(getApiErrorMessage(error, 'Failed to delete requirement. Please try again.'));
          console.error("Error deleting requirement:", error);
        }
      };
      // Edit Requirement
      const fetchRequirement = async (id) => {
        try {
            const { data } = await api.get(`/getrequirements/${id}`);
            setFormData({
              ...data,
              id: data._id,
              clientId: data.clientId ? String(data.clientId) : '',
              startDate: toDateInputValue(data.startDate),
              requirementtype: normalizeRequirementType(data.requirementtype) || data.requirementtype || '',
              assessments: padAssessments(data.assessments),
            });
            setEditJdFile(null);
            setShowEditModal(true);
        } catch (error) {
            console.error('Failed to fetch requirement data');
        }
      };
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleEditClientChange = ({ clientId, client }) => {
      setFormData((prevData) => ({
        ...prevData,
        clientId,
        client,
      }));
    };
    const handleAssessmentChange = (index, e) => {
      const { name, value } = e.target;
      const updatedAssessments = [...formData.assessments];
      updatedAssessments[index][name] = value;
      setFormData((prevData) => ({
          ...prevData,
          assessments: updatedAssessments,
      }));
    };
    const addAssessment = () => {
      setFormData((prevData) => ({
          ...prevData,
          assessments: [...prevData.assessments, { assessment: '', yoe: '' }],
      }));
    };
    const deleteAssessment = (index) => {
      if (formData.assessments.length <= MIN_ASSESSMENTS) {
        showError(`Minimum ${MIN_ASSESSMENTS} assessments are required.`);
        return;
      }
      const newAssessments = formData.assessments.filter((_, i) => i !== index);
      setFormData({
          ...formData,
          assessments: newAssessments,
      });
    };
    const handleEditJdChange = (event) => {
      const file = event.target.files?.[0];
      if (!file) {
        setEditJdFile(null);
        return;
      }
      if (file.type !== 'application/pdf') {
        showError('JD must be a PDF file.');
        event.target.value = '';
        setEditJdFile(null);
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showError('JD PDF must be 5 MB or smaller.');
        event.target.value = '';
        setEditJdFile(null);
        return;
      }
      setEditJdFile(file);
    };
    const handleSubmit = async (e) => {
      e.preventDefault();
      const assessmentValidation = validateAssessmentsInput(formData.assessments);
      if (!assessmentValidation.ok) {
        showError(assessmentValidation.message);
        return;
      }

      try {
          const payload = {
            ...formData,
            assessments: assessmentValidation.assessments,
            update: 'Old',
          };
          delete payload.jdPdf;
          delete payload.jdPdfOriginalName;
          delete payload.assignedMembers;
          delete payload.userUploadSettings;
          delete payload.workflow;
          delete payload.claimedBy;
          delete payload.currentClaimedBy;
          delete payload.userDetails;

          const multipart = new FormData();
          appendRequirementFormData(multipart, payload, editJdFile);
          await editRequirement(formData.id, multipart);
          showSuccess('Requirement updated successfully');
          setShowEditModal(false);
          setEditJdFile(null);
          await fetchRequirements();
      } catch (err) {
          console.error(err);
          showError(getApiErrorMessage(err, 'Error updating requirement.'));
      }
    }; 
// Function to fetch requirement details without Axios
const fetchRequirementDetails = async (reqId) => {
  try {
      const response = await api.get(`/admingetrequirements/${reqId}`);
      const data = response.data;
      const assignedUsers = Array.isArray(data.userDetails) ? data.userDetails : [];

      setAssignedUserDetails(assignedUsers);
      SetRequirements((prev) => prev.map((item) => (
          String(item._id) === String(reqId)
              ? { ...item, userCount: assignedUsers.length }
              : item
      )));
      fetchRemainingUsers(reqId);
      setShowAssigns(true);
      setSelectedReqId(reqId);
  } catch (err) {
      console.error('Error fetching requirement details:', err);
      showError(err.message || 'Unable to load assignment details for this requirement.');
  }
};

const fetchRemainingUsers = async (reqId) => {
  try {
      // Make a GET request to the /remainingusers/:id API using Axios
      const response = await api.get(`/remainingusers/${reqId}`);
      
      // Set the remaining users in the state
      setRemainingUsers(response.data);
  } catch (err) {
      console.error('Error fetching remaining users:', err.message);
  }
};

const assignReqToUser = async (userId) => {
  const ReqId = selectedReqId; // Ensure you have a way to store the selected requirement ID

  // Show a confirmation dialog to the user
  const isConfirmed = window.confirm(`Are you sure you want to assign this Requirement?`);

  // If the user confirms, proceed with the assignment
  if (isConfirmed) {
      try {
          const response = await api.post(`/assignReq/${userId}/${ReqId}`);

          const result = response.data;

          if (result.status === 'success') {
              showSuccess('Requirement assigned successfully ✓');

              // Re-fetch the requirement details (assigned users and remaining users)
              fetchRequirementDetails(ReqId);
          } else {
              showError(result.msg || 'Failed to assign requirement. Please try again.');
          }
      } catch (error) {
          console.error('Error assigning requirement:', error.response ? error.response.data : error.message);
          showError(getApiErrorMessage(error, 'An error occurred while assigning the requirement. Please try again later.'));
      }
  } else {
      showInfo('Requirement assignment was canceled.');
  }
};

// Function to unassign requirement from a user
const unassignReqFromUser = async (userId) => {
  const ReqId = selectedReqId;
  const targetUser = assignedUserDetails.find((item) => String(item._id) === String(userId));
  const isTeamLeadTarget = targetUser?.userType === 'TeamLead';
  const confirmMessage = isTeamLeadTarget
    ? 'Unassign this requirement from the Team Lead? The client assignment will remain unchanged.'
    : 'Are you sure you want to unassign this Requirement?';

  const isConfirmed = window.confirm(confirmMessage);

  // If the user confirms, proceed with the unassignment
  if (isConfirmed) {
    try {
      const response = await api.post(`/unassignReq/${userId}/${ReqId}`);
      const result = response.data;

      if (result.status === 'success') {
        showSuccess('Requirement unassigned successfully ✓');
        // Refresh the UI or re-fetch data if necessary
        fetchRequirementDetails(ReqId); // Re-fetch requirement details to update the user list
      } else {
        showError(result.msg || 'An error occurred while unassigning the requirement. Please try again later.');
      }
    } catch (error) {
      console.error('Error unassigning requirement:', error);
      showError(getApiErrorMessage(error, 'An error occurred while unassigning the requirement. Please try again later.'));
    }
  } else {
      showInfo('Requirement unassignment was canceled.');
  }
};

const toggleAssignedUserUploadStatus = async (userId, isManuallyActive) => {
  await confirmAndToggleAssignedUserUploadStatus(
    selectedReqId,
    userId,
    isManuallyActive,
    () => fetchRequirementDetails(selectedReqId),
  );
};


    return (
        <PageShell
            title={isMyRequirements ? 'My Requirements' : 'Requirement List'}
            breadcrumbs={[
                { label: 'Dashboard', path: '/dashboard' },
                { label: 'Requirements', path: '/requirements' },
                { label: isMyRequirements ? 'My Requirements' : 'Requirement List' },
            ]}
            backTo="/requirements"
            actions={(
              <Button variant="primary" className="hr-btn-primary" onClick={() => openFormModal('create-requirement')}>
                + Add Requirement
              </Button>
            )}
        >
                {loadError && <div className="alert alert-danger">{loadError}</div>}
                {loading && <p className="hr-empty-state">Loading requirements...</p>}
                {!loading && !loadError && (
                    <>
                    <p className="hr-list-summary">
                        Showing <strong>{visibleRequirements.length}</strong> requirements
                    </p>
                    {focusedRequirementId && (
                        <div className="hr-page-hint mb-3 d-flex flex-wrap align-items-center gap-2">
                            <span>
                                Showing the requirement selected from Latest Requirements.
                            </span>
                            <Button variant="outline-primary" size="sm" onClick={clearFocusedRequirement}>
                                Show all requirements
                            </Button>
                        </div>
                    )}
                    {!focusedRequirementId && matchesDefaultRequirementListMonthRange(uploadedFromDate, uploadedToDate) && (
                        <p className="hr-page-hint mb-3">
                            Showing requirements uploaded in the last 60 days by default (
                            {formatDisplayDate(uploadedFromDate)}
                            {' – '}
                            {formatDisplayDate(uploadedToDate)}
                            ). Adjust the date range to view older requirements.
                        </p>
                    )}
                    </>
                )}
                <div className="hr-toolbar">
            <div className="hr-toolbar-main">
                <FormControl
            className="hr-search"
            type='search'
                    placeholder="Search by client, role, or requirement ID"
                    aria-label="Search by client, role, or requirement ID"
                    value={searchReq}
                    onChange={handleSearchChange}
                />
                <RequirementDateRangeFilter
                    fromDate={uploadedFromDate}
                    toDate={uploadedToDate}
                    defaultFromDate={INITIAL_REQUIREMENT_LIST_MONTH_RANGE.from}
                    defaultToDate={INITIAL_REQUIREMENT_LIST_MONTH_RANGE.to}
                    onFromChange={(value) => {
                        setUploadedFromDate(value);
                        setListPage(1);
                    }}
                    onToChange={(value) => {
                        setUploadedToDate(value);
                        setListPage(1);
                    }}
                />
            </div>
                <div className="hr-table-toolbar-right">
                    <Button variant="outline-secondary" size="sm" onClick={fetchRequirements}>
                        ↻ Refresh
                    </Button>
                    <Button variant="outline-secondary" size="sm" onClick={handleImportClick}>
                        Import
                    </Button>
                    <input
                        ref={importInputRef}
                        type="file"
                        accept={EXCEL_ACCEPT}
                        className="hr-import-input"
                        onChange={handleImportFile}
                    />
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={handleDownloadTemplate}
                    >
                        Download Template
                    </Button>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={handleExportRequirements}
                        disabled={!exportRows.length}
                    >
                        Export Excel
                    </Button>
                </div>
                </div>
            <div className="hr-table-card">
            <div className="hr-role-filters">
                <DropdownButton
                    title={getDropdownTitle()}
                    variant="outline-secondary"
                    id="dropdown-checkbox"
                    className="hr-requirement-type-filter"
                >
                    {/* 'All' Option */}
                    <Dropdown.Item
                        as="div"
                        key="all"
                        onClick={(e) => e.stopPropagation()}
                        style={{ fontWeight: 'bold' }}
                    >
                        <input
                            type="checkbox"
                            id="checkbox-all"
                            checked={selectedTypes.length === requirementTypes.length}
                            onChange={() => handleCheckboxChange('all')}
                        />
                        <label htmlFor="checkbox-all" style={{ marginLeft: '10px' }}>
                            All
                        </label>
                    </Dropdown.Item>

                    {requirementTypes.map((type) => (
                        <Dropdown.Item
                            as="div"
                            key={type}
                            onClick={(e) => e.stopPropagation()}
                            style={{ fontWeight: 'bold' }}
                        >
                            <input
                                type="checkbox"
                                id={`checkbox-${type}`}
                                checked={selectedTypes.includes(type)}
                                onChange={() => handleCheckboxChange(type)}
                            />
                            <label htmlFor={`checkbox-${type}`} style={{ marginLeft: '10px' }}>
                                {type}
                            </label>
                        </Dropdown.Item>
                    ))}
                </DropdownButton>
                
            </div>

            <Col md={6} className="mb-2">
                <Toast style={{ backgroundColor: "indianred" }} onClose={() => setShowB(false)} show={showB} animation={false}>
                    <Toast.Header>
                        <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
                        <strong className="me-auto">
                            <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon" />
                            <b style={{ fontSize: "20px", fontFamily: "serif", textAlign: "center" }}> No Uploads</b>
                        </strong>
                    </Toast.Header>
                </Toast>
            </Col>
            {/* Table */}
            <div className="table-responsive">
            <Table bordered hover className="hr-table table-sm hr-requirement-list-table">
                <thead>
                    <tr>
                        <th>Reg Id</th>
                        <th>Client</th>
                        <th>Role</th>
                        <th>Type Of Contract</th>
                        <th>Requirement Type</th>
                        {!isMyRequirements && <th>Source</th>}
                        <th>Priority</th>
                        <th>Start Date</th>
                        <th>Uploaded On</th>
                        <th>Assigns</th>
                        <th>No of Profiles</th>
                        <th>Ongoing Profiles</th>
                        <th>No Action Taken</th>
                        <th>Rejected</th>
                        <th>No of Claims</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
      {!loading && pagedRequirements.length === 0 ? (
        <tr>
          <td colSpan={isMyRequirements ? 15 : 16} className="hr-empty-state">No requirements found.</td>
        </tr>
      ) : (
      pagedRequirements.map((item) => (
          <React.Fragment key={item._id}>
            {/* Main row */}
            <tr
              id={`requirement-row-${item._id}`}
              className={flashRequirementId === item._id ? 'hr-requirement-row-highlight' : undefined}
            >
              <td>
                {(item.priority != null && item.priority !== '') || isRequirementWorkBlocked(item.requirementtype) ? (
                  <div className="hr-req-row-indicators">
                    <PriorityBadge priority={item.priority} shortLabel />
                    {isRequirementWorkBlocked(item.requirementtype) && (
                      <span className="hr-requirement-stopped-badge">STOPPED</span>
                    )}
                  </div>
                ) : null}
                <button type="button" className="btn btn-link p-0" style={{ textDecoration: 'none' }} onClick={() => requirementDetails(item._id)}>
                  <b>{item.regId}</b>
                </button>
              </td>
              <td>{item.client}</td>
              <td>{item.role}</td>
              <td>{item.typeOfContract}</td>
              <td>
                <RequirementTypeSelect
                  requirementId={item._id}
                  value={item.requirementtype}
                  onUpdated={(nextType, updatedRequirement) => handleRequirementTypeUpdated(item._id, nextType, updatedRequirement)}
                />
              </td>
              {!isMyRequirements && (
                <td>
                  <span className={`badge ${getRequirementSourceBadgeClass(getRequirementSourceFromRow(item), item)}`}>
                    {getRequirementSourceFromRow(item)}
                  </span>
                </td>
              )}
              <td>
                <PrioritySelect
                  requirementId={item._id}
                  value={item.priority}
                  onUpdated={(nextPriority) => handlePriorityUpdated(item._id, nextPriority)}
                />
              </td>
              <td>{new Date(item.startDate).toLocaleDateString()}</td>
              <td>{new Date(item.uploadedDate).toLocaleDateString()}</td>
              <td>
  <button
    type="button"
    className="btn btn-link p-0"
    onMouseMove={(e) => {
      e.currentTarget.style.backgroundColor = isRequirementWorkBlocked(item.requirementtype) ? "" : "lightpink";
      e.currentTarget.style.color = isRequirementWorkBlocked(item.requirementtype) ? "" : "black";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = isRequirementWorkBlocked(item.requirementtype) ? "" : "gray";
      e.currentTarget.style.color = isRequirementWorkBlocked(item.requirementtype) ? "" : "white";
    }}
    style={{ textDecoration: "none", pointerEvents: isRequirementWorkBlocked(item.requirementtype) ? "none" : "auto" }}
    onClick={() => !isRequirementWorkBlocked(item.requirementtype) && fetchRequirementDetails(item._id)}
    disabled={isRequirementWorkBlocked(item.requirementtype)}
  >
    <strong style={{ backgroundColor: "dimgrey", borderRadius: "8px", padding: "9px", color: "white" }}>
      {item.userCount}
    </strong>
  </button>
</td>
              <td>
                <button
                  type="button"
                  className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn"
                  onClick={() => openProfilesModal(
                    item._id,
                    item.regId,
                    'all',
                    getNoOfProfilesCandidatesForRequirement(item)
                  )}
                >
                  <strong>{getUploadedProfileCount(item)}</strong>
                </button>
              </td>
              <td>
                <button
                  type="button"
                  className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn"
                  onClick={() => openProfilesModal(
                    item._id,
                    item.regId,
                    'ongoing',
                    getActiveCandidatesForRequirement(item)
                  )}
                >
                  <strong>{getOngoingProfileCount(item)}</strong>
                </button>
              </td>
              <td>
                {(() => {
                  const noActionCandidates = getNoActionCandidatesForRequirement(item);
                  const noActionCount = noActionCandidates.length;
                  return (
                    <button
                      type="button"
                      className={`btn btn-link p-0 hr-table-link-btn hr-table-count-btn${noActionCount === 0 ? ' is-zero' : ' is-alert'}`}
                      onClick={() => openProfilesModal(item._id, item.regId, 'no-action', noActionCandidates)}
                    >
                      <strong>{noActionCount}</strong>
                    </button>
                  );
                })()}
              </td>
              <td>
                <button
                  type="button"
                  className={`btn btn-link p-0 hr-table-link-btn hr-table-count-btn${(item.rejectedCandidatesCount || 0) === 0 ? ' is-zero' : ' is-alert'}`}
                  onClick={() => openRejectedModal(item._id, item.regId)}
                >
                  <strong>{item.rejectedCandidatesCount || 0}</strong>
                </button>
              </td>
              <td>
                <button
                  type="button"
                  className="btn btn-link p-0 hr-table-link-btn hr-table-count-btn"
                  onClick={() => fetchClaimedUsersDetails(item._id, item.regId)}
                >
                  <strong>{claimedByCounts[item._id] ?? 0}</strong>
                </button>
              </td>
              <td>
                <div className="hr-table-actions hr-req-row-actions">
                  <button
                    type="button"
                    className={`hr-req-row-action hr-req-row-action--expand${openItems[item._id] ? ' is-open' : ''}`}
                    onClick={() => toggleAccordion(item._id)}
                    title="Expand Requirement"
                    aria-label="Expand Requirement"
                  >
                    <Image src="./Images/expand.svg" alt="" />
                    <span>Expand</span>
                  </button>
                  <button
                    type="button"
                    className="hr-req-row-action hr-req-row-action--edit"
                    onClick={() => fetchRequirement(item._id)}
                    title="Edit"
                    aria-label="Edit"
                  >
                    <Image src="./Images/edit.svg" alt="" />
                    <span>Edit</span>
                  </button>
                  <button
                    type="button"
                    className="hr-req-row-action hr-req-row-action--delete"
                    onClick={() => handleDelete(item._id)}
                    title="Delete"
                    aria-label="Delete"
                  >
                    <Image src="./Images/trash.svg" alt="" />
                    <span>Delete</span>
                  </button>
                </div>
              </td>
            </tr>

            {/* Conditionally render the accordion row below the main row */}
            {expandedId === item._id && (
              <tr>
                <td colSpan={12}>
                  <Accordion activeKey="0">
                    <Accordion.Item eventKey="0">
                      {/* <Accordion.Header>More Details</Accordion.Header> */}
                      <Accordion.Body>
                      <Table  bordered hover responsive className="table-sm" style={{ textAlign: "center" }}>
                <thead>
                    <tr>
                        <th>Employee Name</th>
                        <th>Source Profile Name</th>
                        <th>Role</th>
                        <th>ECTC</th>
                        <th>LWD</th>
                        <th>Uploaded Date</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredRecruitersData.map((item, i) => (
                        <React.Fragment key={i}>
                            {item.candidates.length > 0 ? (
                                item.candidates.filter(candidate => {
                                    const recentStatus = getPersistedCandidateStatus(candidate);

                                    const matchesStatus = selectedCandidateStatus ? recentStatus === selectedCandidateStatus : true;
                                    const matchesName = candidateName 
                                        ? `${candidate.firstName} ${candidate.lastName}`.toLowerCase().includes(candidateName.toLowerCase())
                                        : true;

                                    return matchesStatus && matchesName;
                                }).map((candidate, index) => {
                                    const persistedStatus = getPersistedCandidateStatus(candidate);

                                    return (
                                        <tr
                                            key={candidate._id || index}
                                            id={candidate._id ? `profile-row-${candidate._id}` : undefined}
                                        >
                                            {index === 0 && (
                                                <td rowSpan={item.candidates.length}>{item.recruiter.EmployeeName}</td>
                                            )}
                                            <td>{candidate.firstName} {candidate.lastName}</td>
                                            <td>{candidate.role}</td>
                                            <td>{candidate.ectc}</td>
                                            <td>{formatLwdDisplay(candidate.lwd)}</td>
                                            <td>{formatDisplayDate(candidate.uploadedOn)}</td>
                                            <td>
                                                <StatusBadge status={persistedStatus} useStoredLabel />
                                            </td>
                                            <td>
                                                <ActionIcon
                                                    variant="view"
                                                    src="/Images/view.svg"
                                                    alt="View candidate"
                                                    onClick={() => CandidateData(candidate._id)}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr key={i}>
                                    <td>{item.recruiter.EmpCode}</td>
                                    <td>{item.recruiter.EmployeeName}</td>
                                    <td colSpan={6}>No Source Profiles</td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </Table>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </td>
              </tr>
            )}
          </React.Fragment>
        ))
      )}
    </tbody>

            </Table>
            </div>

            {visibleRequirements.length > DEFAULT_LIST_PAGE_SIZE && (
                <div className="hr-pagination">
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        disabled={currentListPage <= 1}
                        onClick={() => setListPage((p) => Math.max(1, p - 1))}
                    >
                        Previous
                    </Button>
                    <span>
                        Page {currentListPage} of {totalListPages} ({visibleRequirements.length} records)
                    </span>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        disabled={currentListPage >= totalListPages}
                        onClick={() => setListPage((p) => Math.min(totalListPages, p + 1))}
                    >
                        Next
                    </Button>
                </div>
            )}
            
            <RequirementClaimsModal
                show={showClaimsModal}
                onHide={closeClaimsModal}
                subtitle={claimsModalMeta.regId ? `Req ID: ${claimsModalMeta.regId}` : ''}
                claimedUsers={showClaimedUsers}
            />

            <RequirementRecruitersModal
                show={showProfilesModal}
                onHide={closeProfilesModal}
                title={
                  profilesModalMeta.mode === 'no-action'
                    ? 'No Action Taken'
                    : profilesModalMeta.mode === 'ongoing'
                      ? 'Ongoing Profiles'
                      : 'Source Profiles'
                }
                subtitle={profilesModalMeta.regId ? `Req ID: ${profilesModalMeta.regId}` : ''}
                recruitersData={recruitersData}
                noActionFilter={profilesModalMeta.mode === 'no-action'}
                scopedCandidates={profilesModalMeta.scopedCandidates}
                onViewCandidate={CandidateData}
            />

            <RequirementRejectedModal
                show={showRejectedModal}
                onHide={closeRejectedModal}
                subtitle={rejectedModalMeta.regId ? `Req ID: ${rejectedModalMeta.regId}` : ''}
                rows={rejectedRows}
                loading={rejectedLoading}
                editableStatus
                updatedBy={currentAdminId}
                onStatusUpdated={handleRejectedStatusUpdated}
            />

                <Modal size="lg" show={lgShow} onHide={() => setLgShow(false)} aria-labelledby="example-modal-sizes-title-lg">
    <Modal.Header closeButton>
        <div className="d-flex w-100 align-items-center justify-content-between gap-2 me-2 flex-wrap">
        <Modal.Title id="example-modal-sizes-title-lg" className="mb-0">
            <h5 className="mb-0"> <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img><b style={{fontFamily:"monospace"}} >RegId:</b>{requirementData.regId}</h5>
        </Modal.Title>
        <Button
          type="button"
          variant="outline-primary"
          size="sm"
          className="hr-btn-primary-outline"
          disabled={!requirementData?._id}
          onClick={() => {
            if (!requirementData?._id) return;
            const sourceId = requirementData._id;
            setLgShow(false);
            openFormModal('create-requirement', { duplicateRequirementId: sourceId });
          }}
        >
          Copy
        </Button>
        </div>
    </Modal.Header>
    <Modal.Body>
    <div className="table-responsive">
    <Table  bordered hover className="table-sm">
                    <tbody>
                        <tr>
                            <td><b>Client:</b></td>
                            <td>{requirementData.client}</td>
                        </tr>
                        <tr>
                            <td><b>Requirement Type:</b></td>
                            <td>{normalizeRequirementType(requirementData.requirementtype)}</td>
                        </tr>
                        <tr>
                            <td><b>Priority:</b></td>
                            <td>
                              <PrioritySelect
                                requirementId={requirementData._id}
                                value={requirementData.priority}
                                onUpdated={(nextPriority) => {
                                  handlePriorityUpdated(requirementData._id, nextPriority);
                                  SetRequirementData((prev) => ({ ...prev, priority: nextPriority }));
                                }}
                              />
                            </td>
                        </tr>
                        <tr>
                            <td><b>Type Of Contract:</b></td>
                            <td>{requirementData.typeOfContract}</td>
                        </tr>
                        <tr>
                            <td><b>Start Date:</b></td>
                            <td>{new Date(requirementData.startDate).toLocaleDateString()}</td>
                        </tr>
                        <tr>
                            <td><b>Duration:</b></td>
                            <td>{requirementData.duration}</td>
                        </tr>
                        <tr>
                            <td><b>Number of Positions:</b></td>
                            <td>{requirementData.numberOfPositions ?? 1}</td>
                        </tr>
                        <tr>
                            <td><b>Location:</b></td>
                            <td>{requirementData.location}</td>
                        </tr>
                        <tr>
                            <td><b>Source CTC:</b></td>
                            <td>{requirementData.sourceCtc}</td>
                        </tr>
                        <tr>
                            <td><b>ECTC:</b></td>
                            <td>{requirementData.ectc || '—'}</td>
                        </tr>
                        <tr>
                            <td><b>Qualification:</b></td>
                            <td>{requirementData.qualification}</td>
                        </tr>
                        <tr>
                            <td><b>YOE:</b></td>
                            <td>{requirementData.yearsExperience}</td>
                        </tr>
                        <tr>
                            <td><b>Relevant YOE:</b></td>
                            <td>{requirementData.relevantExperience}</td>
                        </tr>
                        <tr>
                            <td><b>Skill:</b></td>
                            <td>{requirementData.skill}</td>
                        </tr>
                        <tr>
                            <td><b>Uploaded Date:</b></td>
                            <td>{ new Date(requirementData.uploadedDate).toLocaleDateString()}</td>
                        </tr>
                        <tr>
                            <td><b>JD PDF:</b></td>
                            <td><RequirementJdActions requirement={requirementData} /></td>
                        </tr>

                        {/* Assessment Section */}
                          <tr>
                            <td colSpan="2"><center><label> <h5> <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img><b style={{fontFamily:"monospace"}} >Assessment</b></h5></label></center></td>
                        </tr>
                        {requirementData.assessments && requirementData.assessments.length > 0 ? (
                             requirementData.assessments.map((assessment, index) => (
                             <React.Fragment key={index}>
                                   <tr>
                                       <td><b>Assessment:</b></td>
                                       <td>{assessment.assessment}</td>
                                   </tr>
                                   <tr>
                                       <td><b>Expected Rating:</b></td>
                                       <td>{assessment.yoe}</td>
                                   </tr> <hr></hr>
                               </React.Fragment>
                           ))) : (
                                    <tr>
                                         <td colSpan="2">No assessments available</td>
                                    </tr>
                            )}
                    </tbody>
                </Table>
                </div>
    </Modal.Body>
               </Modal>
           
            <Modal
                show={lagShow}
                onHide={() => setLagShow(false)}
                size="xl"
                centered
                className="hr-modal"
                backdrop="static"
            >
            <Modal.Header closeButton className="hr-modal-header">
                <Modal.Title>
                    <div className="hr-modal-title">
                        <img src="/Images/icon.png" alt="" className="hr-modal-icon" />
                        <div>
                            <h5 className="mb-0">Source Profile Details</h5>
                            {candidateDetails && candidateDetails.firstName ? (
                                <small className="text-muted">
                                    {`${candidateDetails.firstName} ${candidateDetails.lastName || ''}`.trim()}
                                </small>
                            ) : null}
                        </div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="hr-modal-body">
            { candidateDetails && (
    <div className="table-responsive">
    <Table  bordered hover className="table-sm">
        <tbody>
        <tr>
      <td> <Image  src={buildApiAssetUrl(candidateDetails.candidateImage)} style={{width:"100px",borderRadius:"100px"}} alt='Candidate Image' ></Image>
      </td>
      <center>
    <StatusUpdatePanel
      selectedStatus={selectedStatus}
      onStatusChange={handleStatusChange}
      statusRemark={statusRemark}
      onRemarkChange={(event) => setStatusRemark(event.target.value)}
      statusInterviewDate={statusInterviewDate}
      onInterviewDateChange={(event) => setStatusInterviewDate(event.target.value)}
      onSubmit={() => postStatus(candidateId)}
      layout="inline"
    />
      </center>
  <hr />

  <StatusHistorySection
    candidate={candidateDetails}
    candidateId={candidateId}
    onRemarkAdded={handleStatusRemarkAdded}
  />
    </tr>
            <tr>
                <td><b>Source Profile Name</b></td>
                <td>{candidateDetails.firstName} {candidateDetails.lastName}</td>
            </tr>
            <tr>
                <td><b>Email:</b></td>
                <td>{candidateDetails.email}</td>
            </tr>
            <tr>
                <td><b>Dob:</b></td>
                <td>{formatDisplayDate(candidateDetails.dob)}</td>
            </tr>
            <tr>
                <td><b>Mobile Number:</b></td>
                <td>{candidateDetails.mobileNumber}</td>
            </tr>
            <tr>
                <td><b>Skills:</b></td>
                <td>{candidateDetails.candidateSkills}</td>
            </tr>
            <tr>
                <td><b>Ctc:</b></td>
                <td>{candidateDetails.ctc}</td>
            </tr>
            <tr>
                <td><b>Ectc:</b></td>
                <td>{candidateDetails.ectc}</td>
            </tr>
            <tr>
                <td><b>Educational Qualification:</b></td>
                <td>{candidateDetails.educationalQualification}</td>
            </tr>
            <tr>
                <td><b>Total YOE:</b></td>
                <td>{candidateDetails.totalYoe}</td>
            </tr>
            <tr>
                <td><b>Relevant YOE:</b></td>
                <td>{candidateDetails.relevantYoe}</td>
            </tr>
            <tr>
              <td><strong>Current Location:</strong></td>
              <td>{candidateDetails.currentLocation}</td>
           </tr>
            <tr>
                <td><b>Preferred Location:</b></td>
                <td>{candidateDetails.prefLocation}</td>
            </tr>
            <tr>
                <td><b>Current Org:</b></td>
                <td>{candidateDetails.currentOrg}</td>
            </tr>
            <tr>
                <td><b>Role:</b></td>
                <td>{candidateDetails.role}</td>
            </tr>
            <tr>
                <td><b>Resignation Served:</b></td>
                <td>{candidateDetails.resignationServed}</td>
            </tr>
            <tr>
                <td><b>LWD:</b></td>
                <td>{formatLwdDisplay(candidateDetails.lwd)}</td>
            </tr>
            {/* <tr>
                <td><b>Internal Screening:</b></td>
                <td>{candidateDetails.internalScreening}</td>
            </tr> */}
            <tr>
                <td><b>Offer In Hand:</b></td>
                <td>{candidateDetails.offerInHand}</td>
            </tr>
            <tr>
                <td><b>Interview Date:</b></td>
                <td>{formatInterviewDate(candidateDetails.interviewDate)}</td>
            </tr>
            <tr>
                <td><b>About Source Profile:</b></td>
                <td>{candidateDetails.details}</td>
            </tr>
            <tr>
                <td><b>Recruiter Feedback:</b></td>
                <td>{candidateDetails.feedback}</td>
            </tr>
            <tr>
                <td><b>Remark:</b></td>
                <td>{candidateDetails.remark}</td>
            </tr>
            {/* <tr>
                <td><b>Shared With Client:</b></td>
                <td>{candidateDetails.sharedWithClient}</td>
            </tr> */}
            <SourceProfileDocumentFields
              candidateId={candidateId}
              updatedResume={candidateDetails.updatedResume}
              ornnovaProfile={candidateDetails.ornnovaProfile}
              canUpload={canUploadCandidateDocuments}
              onDocumentsUpdated={(updated) => {
                if (!updated) return;
                setCandidateDetails((prev) => (prev ? { ...prev, ...updated } : prev));
              }}
            />
            <tr>
            <td colSpan="2"><center><label> <h5> <img style={{ width: "30px", margin: "10px" }} src='/Images/icon.png' alt="icon"></img><b style={{fontFamily:"monospace"}} >Assessment</b></h5></label></center></td>

            </tr>
            {
                candidateDetails.assessments && Array.isArray(candidateDetails.assessments) && candidateDetails.assessments.length > 0 ? (
                    candidateDetails.assessments.map((item, index) => (
                        <React.Fragment key={index}>
                            <tr>
                                <td><b>Assessment:</b></td>
                                <td>{item.assessment}</td>
                            </tr>
                            <tr>
                                <td><b>Expected Rating:</b></td>
                                <td>{item.yoe}</td>
                            </tr>
                            <tr>
                                <td><b>Candidate Rating:</b></td>
                                <td>{item.score}</td>
                            </tr> <hr></hr>
                        </React.Fragment>
                    ))
                ) : (
                    <tr>
                        <td colSpan={2}>No assessments available.</td>
                    </tr>
                )
            }
        </tbody>
    </Table>
    </div>
    )}
    </Modal.Body>
    <Modal.Footer className="hr-modal-footer">
        <Button variant="secondary" onClick={() => setLagShow(false)}>
            Close
        </Button>
    </Modal.Footer>
            </Modal>

            <Modal size="lg" centered scrollable className="hr-form-modal" show={showEditModal} onHide={() => setShowEditModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Edit Requirement</Modal.Title>
  </Modal.Header>
  <Modal.Body>
  {showEditModal && (
            <div className="edit-requirement-modal">
               <form
  id="edit-requirement-form"
  style={{
    padding: "10px 0",
    maxWidth: "100%",
  }}
  onSubmit={handleSubmit}
>
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      marginBottom: "20px",
    }}
  >
    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="client"><strong>Client</strong></label>
      <RequirementClientSelect
        id="client"
        mode="admin"
        clientId={formData.clientId}
        clientName={formData.client}
        onChange={handleEditClientChange}
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>

    <div style={{ flex: "1", minWidth: "250px" }}>
  <label htmlFor="typeOfContract"><strong>Type of Contract</strong></label>
  <select
    name="typeOfContract"
    value={formData.typeOfContract}
    onChange={handleChange}
    required
    style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
  >
    <option value="">Select Contract Type</option>
    <option value="FTE">FTE</option>
    <option value="C2H">C2H</option>
    <option value="FTE/C2H">FTE/C2H</option>
  </select>
</div>

  </div>

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      marginBottom: "20px",
    }}
  >
    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="startDate"><strong>Start Date</strong></label>
      <input
        type="date"
        name="startDate"
        value={formData.startDate}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>

    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="duration"><strong>Duration</strong></label>
      <input
        type="text"
        name="duration"
        value={formData.duration}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>

    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="numberOfPositions"><strong>Number of Positions</strong></label>
      <input
        type="number"
        min="1"
        name="numberOfPositions"
        value={formData.numberOfPositions ?? 1}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>
  </div>

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      marginBottom: "20px",
    }}
  >
    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="location"><strong>Location</strong></label>
      <input
        type="text"
        name="location"
        value={formData.location}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>

    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="sourceCtc"><strong>Source CTC</strong></label>
      <input
        type="text"
        name="sourceCtc"
        value={formData.sourceCtc}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>

    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="ectc"><strong>ECTC</strong></label>
      <input
        type="text"
        name="ectc"
        value={formData.ectc}
        onChange={handleChange}
        placeholder="Enter ECTC"
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>
  </div>

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      marginBottom: "20px",
    }}
  >
    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="qualification"><strong>Qualification</strong></label>
      <input
        type="text"
        name="qualification"
        value={formData.qualification}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>

    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="yearsExperience"><strong>Years of Experience</strong></label>
      <input
        type="text"
        name="yearsExperience"
        value={formData.yearsExperience}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>
  </div>

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      marginBottom: "20px",
    }}
  >
    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="skill"><strong>Skill</strong></label>
      <input
        type="text"
        name="skill"
        value={formData.skill}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>

    <div style={{ flex: "1", minWidth: "250px" }}>
      <label htmlFor="role"><strong>Role</strong></label>
      <input
        type="text"
        name="role"
        value={formData.role}
        onChange={handleChange}
        required
        style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
      />
    </div>
  </div>

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      marginBottom: "20px",
    }}
  >
    <div style={{ flex: "1", minWidth: "250px" }}>
  <label htmlFor="requirementtype"><strong>Requirement Type</strong></label>
  <select
    name="requirementtype"
    value={normalizeRequirementType(formData.requirementtype)}
    onChange={handleChange}
    required
    style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
  >
    <option value="">Select Requirement Type</option>
    {REQUIREMENT_TYPE_OPTIONS.map((option) => (
      <option key={option} value={option}>{option}</option>
    ))}
  </select>
</div>

  </div>

  <div style={{ marginBottom: '20px' }}>
    <label htmlFor="admin-edit-jd"><strong>JD PDF</strong></label>
    {formData.jdPdf ? (
      <div style={{ margin: '10px 0' }}>
        <RequirementJdActions requirement={formData} />
      </div>
    ) : (
      <div style={{ color: '#666', marginBottom: '8px' }}>No JD uploaded yet.</div>
    )}
    <input
      id="admin-edit-jd"
      type="file"
      accept="application/pdf,.pdf"
      onChange={handleEditJdChange}
      style={{ width: '100%', padding: '10px', borderRadius: '5px' }}
    />
    <div style={{ color: '#666', marginTop: '6px' }}>
      {formData.jdPdf
        ? 'Upload a new PDF to replace the current JD (optional).'
        : 'Optional. PDF only, maximum 5 MB.'}
    </div>
  </div>

  <div className="assessments" style={{ marginBottom: "20px" }}> <hr></hr>
<center>
<h3>
            <img
              style={{ width: "30px", margin: "10px" }}
              src='/Images/icon.png'
              alt="icon"
            />
            <b style={{ fontFamily: "monospace" }}>Assessment *</b>
          </h3>
          <div style={{ color: '#666', marginBottom: '10px' }}>
            Minimum {MIN_ASSESSMENTS} assessments are mandatory.
          </div></center> 
              {formData.assessments.map((assessment, index) => (
      <div
        key={index}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          marginBottom: "10px",
        }}
      >
        <div style={{ flex: "1", minWidth: "250px" }}>
          <label htmlFor={`assessment-${index}`}><strong>Assessment</strong></label>
          <input
            type="text"
            name="assessment"
            value={assessment.assessment}
            onChange={(e) => handleAssessmentChange(index, e)}
            required
            style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
          />
        </div>

        <div style={{ flex: "1", minWidth: "250px" }}>
          <label htmlFor={`yoe-${index}`}><strong>Expected Rating</strong></label>
          <input
            type="string"
            name="yoe"
            value={assessment.yoe}
            onChange={(e) => handleAssessmentChange(index, e)}
            required
            style={{ width: "100%", padding: "10px", borderRadius: "5px" }}
          />
        </div>

        <button
          type="button"
          onClick={() => deleteAssessment(index)}
          style={{
            backgroundColor: "indianred",
            
            padding: "5px",
            borderRadius: "10px",
            border: "none",
            height:"5vh",
            visibility: formData.assessments.length > MIN_ASSESSMENTS ? 'visible' : 'hidden',
          }}
        >
          <img src='./Images/trash.svg' alt="Remove assessment"></img>
        </button>
      </div>
    ))}
    <button
      type="button"
      onClick={addAssessment}
      style={{
        backgroundColor: "green",
        color: "white",
        padding: "10px",
        borderRadius: "5px",
        border: "none",
      }}
    >
      Add Assessment
    </button>
  </div>

  {/* <button
    type="submit"
    style={{
      backgroundColor: "blue",
      color: "white",
      padding: "10px",
      borderRadius: "5px",
      border: "none",
      marginRight: "10px",
    }}
  >
    Update Requirement
  </button> */}

  {/* <button
    type="button"
    onClick={() => setShowEditModal(false)}
    style={{
      backgroundColor: "gray",
      color: "white",
      padding: "10px",
      borderRadius: "5px",
      border: "none",
    }}
  >
    Close
  </button> */}
</form>

            </div>
        )}
    
  </Modal.Body>
  <Modal.Footer className="hr-form-modal-footer">
    <Button variant="secondary" className="hr-btn-secondary" onClick={() => setShowEditModal(false)}>
      Cancel
    </Button>
    <Button variant="primary" className="hr-btn-primary" onClick={() => document.getElementById('edit-requirement-form')?.requestSubmit()}>
      Save
    </Button>
  </Modal.Footer>
</Modal>


<Modal size='lg' show={showAssigns} onHide={
  ()=>{setShowAssigns(false);window.location.reload();}}>
        <Modal.Header closeButton>
          <Modal.Title>
          <h3>
            <img
              style={{ width: "30px", margin: "10px" }}
              src='/Images/icon.png'
              alt="icon"
            />
            <b style={{ fontFamily: "monospace" }}>Assigned Users</b>
          </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body> 
                    <Table bordered hover responsive style={{textAlign:"center"}}>
                        <thead>
                            <tr>
                              <th>Sno</th>
                                <th>Name</th>
                                <th>User Type</th>
                                <th>Upload Status</th>
                                <th>Action</th>
                                <th>Unassign</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assignedUserDetails.map((item,index)=>{
                              const {
                                badgeActive,
                                buttonAction,
                                canToggle,
                                toggleManualActive,
                              } = getUploadDisplayState(item);
                              return(
                                <tr key={item._id || index}> 
                                   <th scope="row">{index + 1}</th>
                                  <td>{item.name}</td>
                                      <td>{item.userType}</td>
                                      <td>
                                        <UploadStatusBadge isManuallyActive={badgeActive} />
                                      </td>
                                      <td>
                                        <UploadActionButton
                                          isManuallyActive={badgeActive}
                                          buttonAction={buttonAction}
                                          disabled={!canToggle}
                                          onClick={() => {
                                            if (!canToggle) return;
                                            toggleAssignedUserUploadStatus(item._id, toggleManualActive);
                                          }}
                                        />
                                      </td>
                                      <td><Button  onMouseEnter={(e) => e.target.style.backgroundColor = "lightcoral"}
                                                   onMouseLeave={(e) => e.target.style.backgroundColor = "lightsteelblue"} style={{borderRadius:"20px",fontWeight:"bolder",color:"black",border:"0px",backgroundColor:"lightsteelblue"}}  onClick={()=> unassignReqFromUser(item._id)}>{item.userType === 'TeamLead' ? 'Unassign TL' : 'Un Assign'}</Button></td>
                                </tr>)})}
                        </tbody>
                    </Table>   <hr></hr>
                    <h4 style={{textAlign:"center"}}>
            <img
              style={{ width: "30px", margin: "10px" }}
              src='/Images/icon.png'
              alt="icon"
            />
            <b style={{ fontFamily: "monospace" }}>Assign Users</b>
          </h4> <hr></hr>
                    <Table bordered hover responsive style={{textAlign:"center"}} >
                <thead>
                    <tr>
                        <th >Sno</th>
                        <th >Name</th>
                        <th >User Type</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {remainingUsers.length > 0 ? (
                        remainingUsers.map((user, index) => (
                            <tr key={user._id}>
                                <th scope="row">{index + 1}</th>
                                <td>{user.name || 'N/A'}</td>
                                <td>{user.userType || 'N/A'}</td>
                                <td>
  <Button 
    onClick={() => { assignReqToUser(user._id) }} 
    style={{
      backgroundColor: "lightcoral", 
      border: "0px", 
      borderRadius: "20px", 
      color: "black",
      fontWeight:"bold"
    }} 
    onMouseEnter={(e) => e.target.style.backgroundColor = "lightgreen"}
    onMouseLeave={(e) => e.target.style.backgroundColor = "lightcoral"}
  >
    Assign
  </Button>
</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4" style={{ textAlign: 'center' }}>
                                No remaining users found
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </Modal.Body>
        <Modal.Footer>
          
        </Modal.Footer>
      </Modal>

            </div>
        </PageShell>
    );
}

export default Requirements;
